import { Component, OnInit, OnDestroy, Input, Output, TemplateRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AppState } from '../../../core/app-state';
import { FesBaseComponent } from '../../../shared/components/fes-base.component';
import { PathTestDoc } from '../../../core/schema/path-test-schema';
import { PathTestPoint } from '../../../core/models/path-test';
import { DriveTestMapPoint, PathTestMapPoint } from '../../../core/models/mapping';
import { first } from 'rxjs/operators';
import { PathViewStore } from '../../path-test.store';
import { DriveTestDoc } from '../../../core/schema/drive-test-schema';
import { DriveTestPoint } from '../../../core/models';

@Component({
  template: `<div class="modal-header">
  <div class="modal-title">Test Point {{pathMapPoint?.pathTestPoint?.pointId}}</div>
  <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
  </button>
  </div>
  <div class="p-0 m-0">
    <div style="margin-left:25px;margin-bottom:50px;width:450px;height:450px;">
      <app-path-test-plotter class="p-0 m-0"
          [pathTest]="pathTestDoc"
          [mapPoints]="pathMapPoints || []"
          [selectedMapPoint]="pathMapPoint"
          [overlay]="pathTestDoc?.overlay"
          [gpx]="pathTestDoc?.gpx"
          (overlayIntializing)="overlayLoading=$event">
      </app-path-test-plotter>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="modalRef.hide()">OK</button>
  </div>`
})
export class PathTestPointLocatorComponent{

  @Input() pathTestDoc : PathTestDoc | DriveTestDoc
  @Input() pathMapPoint : PathTestMapPoint 
  @Input() pathMapPoints: PathTestMapPoint[] 

  overlayLoading = false
  
  constructor(
    public modalRef : BsModalRef,
  ) {
  }
}


@Component({
  selector: 'app-path-test-point-paginator',
  templateUrl: './path-test-point-paginator.component.html',
  styleUrls: ['./path-test-point-paginator.component.scss']
})
export class PathTestPointPaginatorComponent extends FesBaseComponent implements OnInit, OnDestroy {

  //@Input() pathViewStore: PathViewStore

  @Input() pathMapPoints : PathTestMapPoint[] | DriveTestMapPoint[] = []
  @Input() pathTest : PathTestDoc | DriveTestDoc

  @Input() isSurvey = false

  // parent can set guard to conditionally prevent new selected task child (ex. editor has unsaved work)
  @Input() changeGuard : (current: PathTestPoint | DriveTestPoint, acceptFn: ()=>void) => void = (c,a) => a()

  @Output('selectedPointTest') selectedTestPointSubject = new BehaviorSubject<PathTestPoint | DriveTestPoint>(null)

  public assistanceModal : BsModalRef
  
  public locateModal : BsModalRef

  constructor(appState : AppState, 
        private bsModalService: BsModalService,
        public pathViewStore: PathViewStore ) {
    super(appState)
  }

  ngOnInit() {    
  }

  ngOnDestroy(): void {
    this.destroy()
  }
  
  moveToPrevious = async () => {
    this.pathViewStore.moveToPreviousTestPoint()
  }

  moveToFirst = async () => {
    this.pathViewStore.moveToFirstTestPoint()
  }

  moveToNext = () => {
    this.pathViewStore.moveToNextTestPoint()
  }

  moveToLast = () => {
    this.pathViewStore.moveToLastTestPoint()
  }
  
  onRecordAssistance(template: TemplateRef<any>) {
    this.assistanceModal = this.bsModalService.show(template);
  }
  
  async onLocate() {
    const state = await this.pathViewStore.state$.pipe(first()).toPromise()
    const initialState = {
      pathTestDoc: state.pathTestDoc,
      pathMapPoint: state.mapPoint,
      pathMapPoints: state.mapData.mapPoints
    }
    this.bsModalService.show(PathTestPointLocatorComponent, {ignoreBackdropClick: true, initialState});
  }

  async copyPointId(id: string) {
    const pathTestDoc = await this.pathViewStore.pathTestDoc$.pipe(first()).toPromise()
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = id + "_CYCLE" + pathTestDoc.cycle;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

}
